module.exports = __webpack_public_path__ + "img/02rge2022.c0148cda.svg";